module.exports = __webpack_public_path__ + "static/img/健康管理系统.a9d0f67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webSite/著作权/健康管理系统.png
// module id = e/2T
// module chunks = 1